import { Card, CardContent, Stack, Typography } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import FiltersPanel from "../FiltersPanel";
import CreditFlowsSankey from "../charts/CreditFlowsSankey";
import RegionalDebtFlowNetwork from "../charts/RegionalDebtFlowNetwork";
import type { AnalyticsFilters, FlowRow } from "../types";

type CreditFlowsTabProps = {
  filteredFlowRows: FlowRow[];
  filters: AnalyticsFilters;
  setFilters: Dispatch<SetStateAction<AnalyticsFilters>>;
  creditorRegionOptions: string[];
  borrowerRegionOptions: string[];
  creditorTypeColumns: string[];
  denominationColumns: string[];
  minYear: number;
  maxYear: number;
};

export default function CreditFlowsTab({
  filteredFlowRows,
  filters,
  setFilters,
  creditorRegionOptions,
  borrowerRegionOptions,
  creditorTypeColumns,
  denominationColumns,
  minYear,
  maxYear,
}: CreditFlowsTabProps) {
  return (
    <Stack spacing={2.5}>
      <Card sx={{ px: "1rem", py: "1rem" }}>
        <CardContent>
          <Typography sx={{ fontSize: "1rem", color: "#374151" }}>
            Transparency in debt contracts helps the public understand the
            relationships that exist between creditors and borrowers. Use the
            interactive visualizations to better understand credit flows
            identified in the <strong>#PublicDebtIsPublic</strong> documents,
            including key features of parties and agreements.
          </Typography>
        </CardContent>
      </Card>

      <RegionalDebtFlowNetwork />

      <Card >
        <CardContent>
          <Stack spacing={5} sx={{ px: "1rem", py: "1.5rem" }}>
            <Typography sx={{ fontSize: "1rem", color: "#374151" }}>
              We also care about geographic relationships between borrowers and
              lenders. Here, we show a mapping of relative loan amounts of our
              collected documents from creditor regions to borrower countries,
              including loan characteristics.
            </Typography>

            <CreditFlowsSankey rows={filteredFlowRows} noCard />
            <FiltersPanel
              filters={filters}
              setFilters={setFilters}
              creditorRegionOptions={creditorRegionOptions}
              borrowerRegionOptions={borrowerRegionOptions}
              creditorTypeColumns={creditorTypeColumns}
              denominationColumns={denominationColumns}
              minYear={minYear}
              maxYear={maxYear}
              horizontal
              noCard
            />
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}
